<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-xd-12">
        <div class="box">
          <div class="box-body">
            <member-table />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import memberTableTemp from './Temp/MemberTableTemp.vue'

export default {
  name: 'Tables',
  data () {
    return {
      roleType: 99
    }
  },
  components: {
    'member-table': memberTableTemp
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>

<style scpoed>
@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}

.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}

.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
</style>



// WEBPACK FOOTER //
// MemberTable.vue?21213d1c